import { html, render } from "lit-html";
import { unwatch, watch } from "@escapio/portal/dom/screen";
import {
	loadSlot,
	registerSlot,
} from "@escapio/portal/components/ads/stroer/Ads";
import { onChangeDates } from "@escapio/portal/state/travelData";

export class Banner extends HTMLElement {
	constructor() {
		super();
		this.isLoaded = false;
	}

	connectedCallback() {
		this.slotName = this.getAttribute("slot-name");
		render(html`<div id="${this.slotName}"></div>`, this);

		registerSlot(this.slotName, this.slotName).then(slot => {
			if (this.hasAttribute("pin-to-bottom")) {
				slot.configure({ pinToBottom: true });
			}

			watch(this, this.loadIfVisible.bind(this));
			this.loadIfVisible();

			onChangeDates(this.refresh.bind(this));
		});

		if (typeof super.connectedCallback === "function") {
			super.connectedCallback();
		}
	}

	disconnectedCallback() {
		unwatch(this);
	}

	refresh() {
		if (!this.isLoaded) {
			return;
		}
		loadSlot(this.slotName);
	}

	loadIfVisible() {
		if (this.isLoaded) {
			return;
		}
		loadSlot(this.slotName);
		this.isLoaded = true;
	}
}

customElements.define("esc-stroer-banner", Banner);
